import { ASSET_DESKTOP } from '../elements/assets'
import { ASSET_MOBILE } from '../elements/assets'

export const TEXT_AND_MEDIA_EXTENDED = `
...on textAndMediaExtended_Entry {
  id
  typeHandle

  backgroundColor
  headingTable {
    ... on headingTable_TableRow {
      heading
    }
  }
  heading {
    html
  }
  textPosition
  description

  subheading {
    html
  }

  numberedList
  headingTextTable {
    ... on headingTextTable_TableRow {
      col1
      col2
    }
  }

  ${ ASSET_DESKTOP }
  ${ ASSET_MOBILE }

  extendWithTips
  tipsWithBorder: lightswitch

  tipHeading1
  tipIcon1 {url}
  tipDescription1
  tipHeading2
  tipIcon2 {url}
  tipDescription2
  tipHeading3
  tipIcon3 {url}
  tipDescription3
}
`